import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { Router } from "@angular/router";

@Injectable()
export class AuthGuardGuard implements CanActivate {
  constructor(private bs: BaseService, private router: Router) {

  }
  canActivate( next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    /*Check user is authenticated or not then return response*/
    console.log("canActivate AuthGuardGuard");
    let path = state.url;
    //this.bs.lastPath = state.url;
    console.log(path);
    console.log(this.router.navigated);
    return true;
  }
}
